var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "58px",
    height: "58px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#5c7cfa",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.54701,0.54701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.58789,0v49.04492h26.98047v-49.04492zM181.19336,74.98828v32.23633h105.76953v-32.23633zM150.08203,134.20508v333.60547h34.74805v-136.48828c0,-7.45 6.04023,-13.49024 13.49023,-13.49024h71.51758c7.45,0 13.48828,6.04024 13.48828,13.49024v136.48828h34.74805v-333.60547zM185.29297,166.94727h26.97851v44.26367h-26.97851zM255.88477,166.94727h26.97851v44.26367h-26.97851zM123.1543,185.36523l-101.88086,49.1543v233.48047h101.88086zM344.8457,185.36523v282.63477h101.88086v-233.48047zM185.29297,240.01367h26.97851v44.26172h-26.97851zM255.88477,240.01367h26.97851v44.26172h-26.97851zM58.72461,278.41992h26.97852v77.43164h-26.97852zM382.29688,278.41992h26.97851v76.39453h-26.97851zM211.81055,344.8125v122.99805h44.53711v-122.99805zM58.72461,379.68359h26.97852v31.33008h-26.97852zM382.29688,379.68359h26.97851v31.33008h-26.97851z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.16c24be67f97c2ff8d9904dfcc41245e.svg";
export { ForwardRef as ReactComponent };